export default {
    POST: {
        type: 0,
        typeName: 'Post',
    },
    COLLECTION: {
        type: 1,
        typeName: 'Collection',
    },
    KIOSK: {
        type: 2,
        typeName: 'Kiosk',
    },
    NEXTDAY: {
        type: 3,
        typeName: 'NextDay',
    },
    SAMEDAY: {
        type: 4,
        typeName: 'SameDay',
    },
    CORPORATEKIOSK: {
        type: 5,
        typeName: 'CorporateKiosk',
    },
    SAMEDAYOFFICEDROP: {
        type: 6,
        typeName: 'SameDayOfficeDrop',
    },
    PRINTYOUROWN: {
        type: 7,
        typeName: 'PrintYourOwn',
    },
    MOBILE: {
        type: 8,
        typeName: 'Mobile',
    },
};



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/delivery-options-types.js